import { render, staticRenderFns } from "./order-rating-modal.vue?vue&type=template&id=081f7866&"
import script from "./order-rating-modal.vue?vue&type=script&lang=js&"
export * from "./order-rating-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports